import OperationsController from "../adapters/method.controller";

const updateMethod = async(payload) =>{
    const {id, name, price} = payload
    payload = {
        id: id, 
        name: name,
        price: price,
    }
    const response = await OperationsController.updateMethod(payload)
    return response;
}


export default updateMethod;